import React, { Fragment, useEffect, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Popconfirm, Button, Popover, Drawer, Tabs, Tooltip,
} from 'antd';
import {
  LoadingOutlined, CaretRightFilled,
} from '@ant-design/icons';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import Constants, { toISTDate } from '@Apis/constants';
import AttachmentActions from '@Actions/attachmentActions';
import H3FormInput from '@Uilib/h3FormInput';
import Helpers from '@Apis/helpers';
import closeIcon from '@Images/icons/icon-close-blue.png';
import Attachment from '@Components/Common/Attachment';
import ManualProductionEntryActions from '@Actions/production/manualProductionEntryActions';
import ProductBOM from '@Components/Inventory/ManageProducts/ViewProduct/ProductBOMList/ProductBOM';
import AnalyticsActions from '@Actions/application/analyticsActions';
import { v4 as uuidv4 } from 'uuid';
import RawMaterialsLinesEntry from './Table/RawMaterialLinesEntry';
import ByProductsLinesEntry from './Table/ByProductsLinesEntry';
import OtherChargesLinesEntry from './Table/OtherChargesLinesEntry';
import './style.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import ProductCategoryLabel from '../../../Common/ProductCategoryLabel';

const { TabPane } = Tabs;

function ManualProductionEntryView({
  user, updateManualProductionEntryStatus, getManualProductionEntryById, getManualProductionEntryByIdLoading, selectedManualProductionEntry, getManualProductionEntryByIdSuccess, updateManualProductionEntryStatusLoading,
  MONEY, match, updateAttachmentLoading, updateAttachment, getAttachmentById, history, downloadDocument, priceMasking, isQuickView,
}) {
  const [currentTab, setCurrentTab] = useState('/raw-material');
  const [showBomDrawer, setShowBomDrawer] = useState(false);
  const [call, setCall] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [cancellationReason, setCancellationReason] = useState('');
  const [currentUpdate, setCurrentUpdate] = useState('');
  const [isGetAttachment, setIsGetAttachment] = useState(false);

  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;
  useEffect(() => {
    const payload = {
      tenantId: Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.MO, Helpers.permissionTypes.READ).join(',') || user?.tenant_info?.tenant_id,
      peId: match?.params?.peId,
    };
    getManualProductionEntryById(payload);

    return () => {
      getManualProductionEntryByIdSuccess(null);
    };
  }, [call]);

  useEffect(() => {
    if (selectedManualProductionEntry) {
      setFileList(selectedManualProductionEntry?.attachments);
    }
  }, [selectedManualProductionEntry]);

  function handleFileChange(fileListData) {
    const fileListNew = fileListData?.fileList?.map((item) => ({
      ...item,
      url: item?.response?.response?.location || item?.url,
    }));

    const attachments = fileListNew?.map((attachment) => ({
      url: attachment?.response?.response?.location || attachment?.url, type: attachment.type, name: attachment.name, uid: attachment.uid,
    }));

    if (fileListData?.file.status === 'done') {
      const payload = {
        entity_id: selectedManualProductionEntry?.production_entry_id,
        entity_name: 'manual_production_entry',
        attachments,
      };
      updateAttachment(payload, () => {
        getAttachmentById(selectedManualProductionEntry?.production_entry_id, 'manual_production_entry', () => {
          setIsGetAttachment(true);
        });
      });
    }
    if (fileListData?.file.status === 'removed') {
      const payload = {
        entity_id: selectedManualProductionEntry?.production_entry_id,
        entity_name: 'manufacturing_order',
        attachments,
      };
      updateAttachment(payload, () => {
        getAttachmentById(selectedManualProductionEntry?.production_entry_id, 'manual_production_entry', () => {
          setIsGetAttachment(true);
        });
      });
    }

    setFileList(attachments.length > 0 ? attachments : []);
  }

  return (
    <Fragment>
      <div className={`view-document__wrapper ${!isQuickView ? 'view-document__wrapper-page' : ''}`}>
        <div className="ant-row">
          <div className="ant-col-md-17">
            <div className={`view-left__wrapper ${!isQuickView ? 'is-page-view' : ''}`}>
            {(!getManualProductionEntryByIdLoading || selectedManualProductionEntry)
              ? (
                <Fragment>
                  <div className="view-document__title">
                    <div className="view-document__title-number-wrapper">
                      <H3Text text={selectedManualProductionEntry?.production_entry_number} className="view-document__title-number" />
                      <div className="view-document__title-status" style={{ backgroundColor: Helpers.getStatusColor(selectedManualProductionEntry?.status).color }}>
                        {selectedManualProductionEntry?.status?.replaceAll('_', ' ')}
                      </div>
                    </div>
                    <div className="view-document__title-actions">
                      <div className="action-buttons">
                        <H3Text
                          text={
                            <FontAwesomeIcon icon={faPrint} style={{ fontSize: '16px', width: '35px', textAlign: 'center' }} />
                          }
                          onClick={() => downloadDocument({
                            url: `${Constants.ManualProductionEntry}/download?production_entry_id=${selectedManualProductionEntry?.production_entry_id}&tenant_id=${selectedManualProductionEntry?.tenant_id}`,
                            document_type: 'MANUAL_PRODUCTION_ENTRY',
                            document_number: selectedManualProductionEntry?.production_entry_number,
                            key: uuidv4(),
                          })}
                          className="action-button action-button-big"
                        />
                      </div>
                      {((Helpers.getPermission(Helpers.permissionEntities.MO, Helpers.permissionTypes.UPDATE, user) || Helpers.getPermission(Helpers.permissionEntities.MO, Helpers.permissionTypes.UPDATE, user))) && (
                        <div className="action-buttons">
                          {Helpers.getPermission(Helpers.permissionEntities.MO,
                            Helpers.permissionTypes.UPDATE, user) && selectedManualProductionEntry?.status === 'DRAFT' && (
                            <Popconfirm
                              placement="topRight"
                              title="Are you sure you want to confirm this entry?"
                              onConfirm={() => {
                                updateManualProductionEntryStatus({
                                  tenant_id: selectedManualProductionEntry?.tenant_id,
                                  production_entry_id: selectedManualProductionEntry.production_entry_id,
                                  status: 'ISSUED',
                                }, () => {
                                  setCall(!call);
                                });
                              }}
                              okText="Yes"
                              cancelText="No"
                            >
                              <H3Text
                                text={(
                                  <div>
                                    {updateManualProductionEntryStatusLoading ? <LoadingOutlined /> : (
                                      <span>Confirm</span>
                                    )}
                                  </div>
                                )}
                                className="action-button action-button-big"
                              />
                            </Popconfirm>
                          )}

                          {selectedManualProductionEntry?.status !== 'VOID' && Helpers.getPermission(Helpers.permissionEntities.MO,
                            Helpers.permissionTypes.UPDATE, user) && (
                              <Popover
                                placement="bottom"
                                trigger="click"
                                title="Are you sure you want to cancel?"
                                content={(
                                  <React.Fragment>
                                    <H3FormInput
                                      name="field name"
                                      type="text"
                                      containerClassName="orgInputContainer"
                                      labelClassName="orgFormLabel"
                                      inputClassName="orgFormInput"
                                      placeholder=""
                                      onChange={(event) => setCancellationReason(event.target.value)}
                                      value={cancellationReason}
                                      label="Reason for cancellation"
                                      maxlength="100"
                                      required
                                      showError={currentUpdate === 'VOID' && !cancellationReason}
                                    />

                                    <div className="view-mo__cancellation-buttons">
                                      <Button
                                        onClick={() => {
                                          setCurrentUpdate('VOID');
                                          if (cancellationReason) {
                                            updateManualProductionEntryStatus({
                                              status: 'VOID',
                                              production_entry_id: selectedManualProductionEntry.production_entry_id,
                                              cancellation_reason: cancellationReason,
                                              tenant_id: selectedManualProductionEntry?.tenant_id,
                                            }, () => {
                                              setCurrentUpdate('');
                                              setCall(!call);
                                            });
                                          }
                                        }}
                                        type="primary"
                                        size="small"
                                        loading={updateManualProductionEntryStatusLoading}
                                      >
                                        Yes
                                      </Button>
                                    </div>

                                  </React.Fragment>
                                )}
                              >
                                <H3Text
                                  text={(
                                    <div style={{ width: '50px', textAlign: 'center' }}>
                                      {(updateManualProductionEntryStatusLoading && currentUpdate === 'VOID')
                                        ? <LoadingOutlined /> : (
                                          <span>Cancel</span>
                                        )}
                                    </div>
                                  )}
                                  className="action-button action-button-big"
                                />
                              </Popover>
                            )}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="document-header">
                    <div className="ant-row">
                      <div className="ant-col-md-12">
                        <div className="document-header__field">
                          <H3Text text="Scheduled Date" className="document-header__field-name" />
                          <H3Text text={selectedManualProductionEntry?.production_entry_date ? (toISTDate(selectedManualProductionEntry?.production_entry_date).format('DD/MM/YYYY')) : '-'} className="document-header__field-value" />
                        </div>
                      </div>
                      <div className="ant-col-md-12">
                        <Tooltip title={selectedManualProductionEntry?.tenant_info?.tenant_name}>
                          <div className="document-header__field">
                            <H3Text text="Location" className="document-header__field-name" />
                            <H3Text text={selectedManualProductionEntry?.tenant_info?.tenant_name?.length > 25 ? `${selectedManualProductionEntry?.tenant_info?.tenant_name?.substring(0, 25)}..` : selectedManualProductionEntry?.tenant_info?.tenant_name} className="document-header__field-value" />
                          </div>
                        </Tooltip>
                      </div>
                      <div className="ant-col-md-12">
                        <div className="document-header__field">
                          <H3Text text="Department" className="document-header__field-name" />
                          <H3Text text={selectedManualProductionEntry?.department_name} className="document-header__field-value" />
                        </div>
                      </div>
                      <div className="ant-col-md-12">
                        <div className="document-header__field">
                          <H3Text text="FG Department" className="document-header__field-name" />
                          <H3Text text={selectedManualProductionEntry?.fg_department_name} className="document-header__field-value" />
                        </div>
                      </div>
                      <div className="ant-col-md-12">
                        <div className="document-header__field">
                          <H3Text text="RM Department" className="document-header__field-name" />
                          <H3Text text={selectedManualProductionEntry?.rm_department_name} className="document-header__field-value" />
                        </div>
                      </div>
                      <div className="ant-col-md-12">
                        <div className="document-header__field">
                          <H3Text text="BP Department" className="document-header__field-name" />
                          <H3Text text={selectedManualProductionEntry?.bp_department_name || '-'} className="document-header__field-value" />
                        </div>
                      </div>
                      <div className="ant-col-md-12">
                        <div className="document-header__field">
                          <H3Text text="Overage Tracking" className="document-header__field-name" />
                          <H3Text
                            text={selectedManualProductionEntry?.enable_wastage_tracking ? 'Enabled' : 'Disabled'}
                            className="document-header__field-value"
                          />
                        </div>
                      </div>

                      <div className="ant-col-md-12">
                        <div className="document-header__field">
                          <H3Text text="Created By" className="document-header__field-name" />
                          <H3Text
                            text={selectedManualProductionEntry?.created_at ? `${selectedManualProductionEntry?.created_by_info?.first_name + selectedManualProductionEntry?.created_by_info?.last_name} (${toISTDate(selectedManualProductionEntry?.created_at).format('DD/MM/YYYY')})` : '-'}
                            className="document-header__field-value"
                          />
                        </div>
                      </div>

                      {selectedManualProductionEntry?.remarks && (
                        <div className="ant-col-md-12">
                          <div className="document-header__field">
                            <H3Text text="Remarks" className="document-header__field-name" />
                            <H3Text
                              text={selectedManualProductionEntry?.remarks}
                              className="document-header__field-value"
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="mpe-view-fg__wrapper">
                    <div className="mpe-view-fg">
                      <div>
                        <div>
                          <Link to={`/inventory/product/view/${selectedManualProductionEntry?.finished_goods?.[0]?.product_sku_info?.product_sku_id}`} target="_blank">
                            {`#${selectedManualProductionEntry?.finished_goods?.[0]?.product_sku_info?.internal_sku_code}`}
                          </Link>
                          {' '}
                          {`${selectedManualProductionEntry?.finished_goods?.[0]?.product_sku_info?.ref_product_code ? `${selectedManualProductionEntry?.finished_goods?.[0]?.product_sku_info?.ref_product_code} - ` : ''}${selectedManualProductionEntry?.finished_goods?.[0]?.product_sku_info?.product_sku_name}`}
                        </div>
                        {selectedManualProductionEntry?.finished_goods?.[0]?.remarks && (
                          <H3Text
                            text={`${selectedManualProductionEntry?.finished_goods?.[0]?.remarks}`}
                            className="table-subscript-grey"
                          />
                        )}
                        {selectedManualProductionEntry?.finished_goods?.[0]?.product_batches?.length > 0 && 
                        <H3Text text={`Batch# ${selectedManualProductionEntry?.finished_goods?.[0]?.product_batches?.[0]?.custom_batch_number}`} className="table-subscript-grey" />}    
                        {selectedManualProductionEntry?.finished_goods?.[0]?.product_sku_info?.product_category_info &&
                        selectedManualProductionEntry?.finished_goods?.[0]?.product_sku_info?.product_category_info?.category_path?.length > 0 && (
                        <ProductCategoryLabel
                          categoryPath={selectedManualProductionEntry?.finished_goods?.[0]?.product_sku_info?.product_category_info?.category_path}
                          categoryName={selectedManualProductionEntry?.finished_goods?.[0]?.product_sku_info?.product_category_info?.category_path?.at(
                            -1
                          )}
                          containerStyle={{
                            width: "fit-content",
                          }}
                        />
                        )}                  
                      </div>  
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'end' }}>
                        <div>
                          {`${selectedManualProductionEntry?.finished_goods?.[0]?.quantity} ${selectedManualProductionEntry?.finished_goods?.[0]?.uom_info?.uqc}`}
                        </div>
                        <H3Text
                          text="View Bill of Material"
                          className="table-subscript"
                          onClick={() => {
                            setShowBomDrawer(true);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <Tabs
                    activeKey={currentTab}
                    onChange={(key) => {
                      setCurrentTab(key);
                      history.push(`?tab=${key}`);
                    }}
                    mode="horizontal"
                    type="card"
                  >
                    <TabPane tab="Raw Materials" key="/raw-material" />
                    {selectedManualProductionEntry?.by_products?.length && <TabPane tab="By Products" key="/by-product" />}
                    {selectedManualProductionEntry?.extra_charges?.length && <TabPane tab="Extra Charges" key="/other-charges" />}
                  </Tabs>
                  {currentTab === '/raw-material' && (
                    <div className="mpe-tab-section">
                      <RawMaterialsLinesEntry
                        isIssueSfgEnabled={selectedManualProductionEntry?.is_issue_sfg_enabled}
                        callback={() => {
                          getManualProductionEntryById(selectedManualProductionEntry?.tenant_id, selectedManualProductionEntry?.production_entry_id);
                        }}
                        selectedManualProductionEntry={selectedManualProductionEntry}
                      />
                      <hr className="view-mo__line" />
                    </div>
                  )}
                  {currentTab === '/by-product' && (
                    <div className="mpe-tab-section">
                      {selectedManualProductionEntry?.by_products?.length ? (
                        <Fragment>
                          <ByProductsLinesEntry
                            data={selectedManualProductionEntry?.by_products || []}
                            selectedManualProductionEntry={selectedManualProductionEntry}
                          />
                          <hr className="view-mo__line" />
                        </Fragment>
                      ) : ''}
                    </div>
                  )}
                  {currentTab === '/other-charges' && (
                    <div className="mpe-tab-section">
                      {selectedManualProductionEntry?.extra_charges?.length ? (
                        <Fragment>
                          <OtherChargesLinesEntry
                            data={selectedManualProductionEntry?.extra_charges || []}
                            selectedManualProductionEntry={selectedManualProductionEntry}
                          />
                          <hr className="view-mo__line" />
                        </Fragment>
                      ) : ''}
                    </div>
                  )}

                  <div className="view-document__totals-wrapper">
                    <div className="view__document-footer-left">
                      <Attachment
                        fileList={fileList}
                        disableCase={getManualProductionEntryByIdLoading || updateAttachmentLoading}
                        labelClassName="orgFormLabel"
                        inputClassName=""
                        // containerClassName="text-area__po-container"
                        handleFileChange={(value) => handleFileChange(value)}
                        updateEnable={Helpers.getPermission(Helpers.permissionEntities.MO, Helpers.permissionTypes.UPDATE, user)}
                      />
                    </div>
                  </div>
                </Fragment>
              )
              : (
                //  Loader
                <div className="loader__container">
                  <div className="loader__container-left">
                    <div className="loading-header">
                      {[1, 2, 3, 4].map((item) => (
                        <div key={item} className="loading-header-row">
                          <div className="loading-header__label loadingBlock" />
                          <div className="loading-header__label loadingBlock" />
                        </div>
                      ))}

                    </div>
                    <div className="loading-address">
                      {[1, 2].map((item) => (<div key={item} className="address loadingBlock" />))}
                    </div>
                    <div className="loading-table loadingBlock" />
                    <div className="loading-header loading-total">
                      {[1, 2, 3, 4].map((item) => (
                        <div key={item} className="loading-header-row">
                          <div className="loading-header__label loadingBlock" />
                          <div className="loading-header__label loadingBlock" />
                        </div>

                      ))}
                    </div>
                    <div className="loading-header loading-total">
                      <div className="loading-header-row">
                        <div className="loading-header__label loadingBlock" />
                        <div className="loading-header__label loadingBlock" />
                      </div>
                    </div>
                  </div>
                  <div className="loader__container-right">
                    {[1, 2, 3].map((item) => (
                      <div key={item} className="loader__container-right-row">
                        <div style={{ display: 'flex' }}>
                          <div className="loader__container-right-row__icon loadingBlock" />
                          <div>
                            <div className="loader__container-right-row__head loadingBlock" />
                            <div className="loader__container-right-row__sub-head loadingBlock" />
                            <div className="loader__container-right-row__sub-head loadingBlock" />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Drawer
        visible={showBomDrawer}
        onClose={() => {
          setShowBomDrawer(false);
        }}
        width="1080px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '1030px' }}>
            <H3Text text="View Bill of Materials" className="custom-drawer__title" />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => {
                setShowBomDrawer(false);
              }}
            />
          </div>
        </div>
        <ProductBOM
          bomId={selectedManualProductionEntry?.finished_goods?.[0]?.bom_id}
          callback={() => {
            setCall(!call);
            setShowBomDrawer(false);
          }}
        />
      </Drawer>
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers, MOReducers, AttachmentReducers, ManualProductionEntryReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  getManualProductionEntryByIdLoading: ManualProductionEntryReducers.getManualProductionEntryByIdLoading,
  deleteManualProductionEntryLoading: ManualProductionEntryReducers.deleteManualProductionEntryLoading,
  updateAttachmentLoading: AttachmentReducers.updateAttachmentLoading,
  selectedManualProductionEntry: ManualProductionEntryReducers.selectedManualProductionEntry,
  updateManualProductionEntryStatusLoading: ManualProductionEntryReducers.updateManualProductionEntryStatusLoading,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = (dispatch) => ({
  getManualProductionEntryById: (payload, callback) => dispatch(
    ManualProductionEntryActions.getManualProductionEntryById(payload, callback),
  ),
  deleteManualProductionEntry: (payload, callback) => dispatch(
    ManualProductionEntryActions.deleteManualProductionEntry(payload, callback),
  ),
  updateManualProductionEntryStatus: (payload, callback) => dispatch(ManualProductionEntryActions.updateManualProductionEntryStatus(payload, callback)),
  getManualProductionEntryByIdSuccess: (selectedManualProductionEntry) => dispatch(ManualProductionEntryActions.getManualProductionEntryByIdSuccess(selectedManualProductionEntry)),
  getAttachmentById: (entityId, entityName, callback) => dispatch(AttachmentActions.getAttachmentById(entityId, entityName, callback)),
  updateAttachment: (payload, callback) => dispatch(AttachmentActions.updateAttachment(payload, callback)),
  downloadDocument: (payload, document) => dispatch(AnalyticsActions.downloadDocument(payload, document)),

});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ManualProductionEntryView));
